const state = {
  defaultAvEquipments: [],
  avs: {},
  temporaryEquipmentAvs: [],
  skipEquipmentSelection: false,
  vehicleEquipmentList: [],
  selectedEquipments: []
};

export default state;
